import React, { useState } from 'react';
import useApiStable from '../utils/useApiStable';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const api = useApiStable();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.fetchRaw('/auth/forgot-password', {
        method: 'POST',
        body: JSON.stringify({ email: email.trim() }),
      });
      setSubmitted(true);
    } catch {
      setError('Anfrage konnte nicht gesendet werden. Bitte versuche es später erneut.');
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="container" style={{ maxWidth: '500px', margin: '50px auto', padding: '0 20px' }}>
        <div style={{ background: '#fff', padding: '30px', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }}>
          <h2 style={{ textAlign: 'center', marginBottom: '24px' }}>E-Mail gesendet</h2>
          <div style={{ background: '#e8f5e9', color: '#2e7d32', padding: '16px', borderRadius: '4px', marginBottom: '24px', fontSize: '0.9em' }}>
            Falls für <strong>{email.trim()}</strong> ein Konto existiert, erhältst du in Kürze eine E-Mail mit einem Reset-Link. Prüfe auch deinen Spam-Ordner.
          </div>
          <div style={{ textAlign: 'center', fontSize: '0.9em' }}>
            <a href="/login" style={{ color: '#1976d2', textDecoration: 'none' }}>
              Zurück zum Login
            </a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container" style={{ maxWidth: '500px', margin: '50px auto', padding: '0 20px' }}>
      <div style={{ background: '#fff', padding: '30px', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }}>
        <h2 style={{ textAlign: 'center', marginBottom: '30px' }}>Passwort zurücksetzen</h2>

        <p style={{ color: '#555', fontSize: '0.9em', marginBottom: '24px' }}>
          Gib deine E-Mail-Adresse ein. Du erhältst einen Link zum Zurücksetzen deines Passworts.
        </p>

        {error && (
          <div style={{ background: '#ffebee', color: '#c62828', padding: '12px', borderRadius: '4px', marginBottom: '20px', fontSize: '0.9em' }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
              E-Mail-Adresse
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ddd',
                borderRadius: '4px',
                fontSize: '1em',
                boxSizing: 'border-box',
              }}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '12px',
              background: loading ? '#90a4ae' : '#1976d2',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              fontSize: '1em',
              cursor: loading ? 'not-allowed' : 'pointer',
              fontWeight: '500',
            }}
          >
            {loading ? 'Wird gesendet...' : 'Reset-Link anfordern'}
          </button>

          <div style={{ textAlign: 'center', marginTop: '20px', fontSize: '0.9em' }}>
            <a href="/login" style={{ color: '#1976d2', textDecoration: 'none' }}>
              Zurück zum Login
            </a>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
